import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';
import type { AxiosResponse } from 'axios';

export interface GetCarrierListRequestParams {
  customerKey: number;
}

export const getCarrierListAPI = (params: GetCarrierListRequestParams) => {
  return axiosInstance.request({
    url: `${API.POV}/GetCarrier`,
    method: 'get',
    params,
  });
};

export type CarrierListResponse = {
  // TODO: investigate if we can move it to separate type
  carrierKey: number;
  carrierShortName: string;
  carrierName: string;
  carrierScacCode: string;
  carrierAddr1: string;
  carrierAddr2: string | null;
  carrierCity: string;
  carrierState: string;
  carrierZip: string;
}[];

export const fetchCarrierList = async (params: GetCarrierListRequestParams): Promise<CarrierListResponse> => {
  const response: AxiosResponse<CarrierListResponse> = await getCarrierListAPI(params);
  return response.data;
};
